export default "__VITE_ASSET__C7h$yqv7__"